import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 14px 8px 0;
`;

export const WrapperForm = styled.div`
  width: 50%;
  max-width: 546px;
`;
